import { ApiError } from './client';

export const isRevisionMismatch = (error: unknown): boolean => {
  if (error instanceof ApiError) return error.code === 'REVISION_MISMATCH';
  const body = (error as { request?: { data?: { code?: unknown } } } | null)?.request?.data;
  return body?.code === 'REVISION_MISMATCH';
};

export const isDuplicateTagPlacement = (error: unknown): boolean => {
  if (error instanceof ApiError) return error.code === 'DUPLICATE_TAG_PLACEMENT';
  const body = (error as { request?: { data?: { code?: unknown } } } | null)?.request?.data;
  return body?.code === 'DUPLICATE_TAG_PLACEMENT';
};
